import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Передатчик для команд, отвечает за то, чтобы передавать через брокера список команд
 * @param broker интерфейс для передачи команды
 * @param queue кэш и очередь команд, хранит команды до момента их успешной отправки
 * @param registry хранит список известных команд и умеет их инстанцировать
 */
export var CommandRelay = /*#__PURE__*/function () {
  function CommandRelay(name, broker, queue, registry) {
    var _this = this;
    _classCallCheck(this, CommandRelay);
    this.name = name;
    this.broker = broker;
    this.queue = queue;
    this.registry = registry;
    _defineProperty(this, "relayId", void 0);
    _defineProperty(this, "session", {});
    _defineProperty(this, "relayHandler", function (command, extra, ack) {
      /** Если сообщение пришло от текущего реле, то не надо направлять его назад */
      if ((extra === null || extra === void 0 ? void 0 : extra.relayId) === _this.relayId) return;
      _this.broker.onReady(function () {
        _this.broker.send(_this.registry.toMsg(command), extra, ack);
      });
    });
    this.relayId = Symbol(name);
  }
  _createClass(CommandRelay, [{
    key: "attachTo",
    value: function attachTo(bus) {
      var _this2 = this;
      this.broker.registerHandler(function (msg, extra, ack) {
        bus.execute(_this2.registry.toCommand(msg), _objectSpread({
          relayId: _this2.relayId
        }, extra), ack);
      });
      this.registry.commandTypes.forEach(function (commandType) {
        bus.onCmd(commandType, _this2.relayHandler);
      });
    }
  }]);
  return CommandRelay;
}();